// extracted by mini-css-extract-plugin
export default {"modal":"sso-whitelist-type-modal_modal__SXRm1","content":"sso-whitelist-type-modal_content__iIWpk"};